import { QUERY_KEYS } from '../../../../consts';
import { uploadPatomediService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const uploadPatomediAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.UPLOAD_PATOMEDI,
  mutationFn: () => uploadPatomediService,
});
